module.exports = __webpack_public_path__ + "img/triangle.df951363.svg";